import { Button } from 'antd';
import React from 'react';
import { useHistory } from 'react-router-dom';

import './notFound.scss';

const NotFound = () => {
  const history = useHistory();
  const gotoHome = () => {
    history.push('/dashboard');
  };
  return (
    <div className="wrap-not-found container">
      <div className="not-found-logo">
        <img src="" alt="" />
      </div>
      <div className="wrap-content">
        <div className="title">Page not found</div>
        <div className="dicription">
          We are sorry, the page you requested could not be found. Please go back to the homepage
        </div>
        <div className="dicription-img">
          <img src="" alt="" />
        </div>
        <div className="dicription-action">
          <Button className="action-submit" onClick={() => gotoHome()}>
            GO TO HOME
          </Button>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
